import { ComponentProps } from 'react';
import { PrimaryCard } from '../../assets/styles/components/dashboard.styled';
import { activationProps } from './activationProps';

type InteractiveCardProps = Omit<ComponentProps<typeof PrimaryCard>, 'onClick'> & {
  onActivate?: (event: React.SyntheticEvent<HTMLDivElement>) => void;
};

const InteractiveCard = ({ onActivate, onKeyDown, ...rest }: InteractiveCardProps) => {
  if (!onActivate) return <PrimaryCard onKeyDown={onKeyDown} {...rest} />;

  return <PrimaryCard data-keyboard-item {...activationProps(onActivate, onKeyDown)} {...rest} />;
};

export default InteractiveCard;
